module.exports = __webpack_public_path__ + "static/media/forage.2f3a3091.png";